import React, { useState } from 'react'
import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text, useToast } from '@chakra-ui/react'
import ContextCard from '../ContextCard/ContextCard'
import { useGlobalStore } from '../../store/globalStore'
import { useAccessAPI } from '../../hooks/useAccessAPI'
import UsersService from '../../API/UsersService'
import { toastError, toastSuccess } from '../../utils/globalHelper'
import { useNavigate } from 'react-router-dom'

function ChangeContextModal({isOpen, onClose}) {
    const user = useGlobalStore(state => state.user)
    const setUser = useGlobalStore(state => state.setUser)
    const availableContexts = user.contexts.filter(c => c.id !== user?.active_context?.id)
    const [selectedContext, setSelectedContext] = useState(null)
    const changeContextRequest = useAccessAPI(UsersService.changeActiveContext)
    const toast = useToast()
    const navigate = useNavigate()

    const changeContext = async () => {
        const response = await changeContextRequest(selectedContext?.id)
        if (response?.status === 200) {
            setUser(response.data)
            navigate('/')
            toast(toastSuccess('Контекст изменён'))
        } else {
            toast(toastError('Не удалось изменить контекст'))
        }

        clearSelectAndClose()
    }

    const clearSelectAndClose = () => {
        setSelectedContext(null)
        onClose()
    }

    return (
        <Modal isOpen={isOpen} onClose={clearSelectAndClose} size='xl'>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Смена контекста</ModalHeader>

                <ModalBody>
                    {user.contexts.length && !availableContexts.length
                    ?
                    <Text>
                        {`Вам доступен единственный контекст "${user.active_context.role.title}", и вы уже сделали его активным`}
                    </Text>
                    :
                    <></>
                    }
                    {availableContexts.map((context) => (
                        <ContextCard
                            context={context}
                            selected={selectedContext && selectedContext.id === context.id}
                            key={`modal-context-${context.id}`}
                            onClick={() => setSelectedContext(context)}
                        />
                    ))}
                </ModalBody>

                <ModalFooter>
                    <Button disabled={!selectedContext} onClick={changeContext}>
                        Изменить
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default ChangeContextModal
